import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as companiesActions from '../../../actions/companies';
import { getCompanyLocations, getLocationsListAction } from '../../../actions/locations';
import { getAllSkills, getSkillLevels } from '../../../actions/skills';
import { clearWorkersPredictionsList, searchWorkersAction, searchWorkersForFavorites } from '../../../actions/users';
import { appPath } from '../../../constants';
import { companyTabs } from '../../../constants/companies';
import { Details, Rates, Locations, Departments, Contacts, Payment, Workers } from './Tabs';
import Loader from '../../common/ui/Loader';
import Teaser from './Tabs/Teaser';
import { pushHistoryState, stripHash } from '../../../helpers/routing';
import { getGoogleAddressDetails } from '../../../actions';
import { UIShowConfirm, UIShowAlert } from '../../../actions/ui';
import BackArrow from '../../common/ui/BackArrow';

class CompanyDetails extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
    skillsList: PropTypes.array.isRequired,
    skillLevels: PropTypes.array.isRequired,
    companyLocations: PropTypes.array.isRequired,
    locationsList: PropTypes.array.isRequired,
    workersPredictionsList: PropTypes.array.isRequired,
    getCompanyDetailsAction: PropTypes.func.isRequired,
    editCompanyAction: PropTypes.func.isRequired,
    addCustomRateAction: PropTypes.func.isRequired,
    deleteCustomRateAction: PropTypes.func.isRequired,
    getAllSkills: PropTypes.func.isRequired,
    getSkillLevels: PropTypes.func.isRequired,
    getCompanyLocations: PropTypes.func.isRequired,
    getLocationsListAction: PropTypes.func.isRequired,
    getCompanyContacts: PropTypes.func.isRequired,
    getCompanyDepartments: PropTypes.func.isRequired,
    editCompanyDepartment: PropTypes.func.isRequired,
    createCompanyDepartment: PropTypes.func.isRequired,
    getGoogleAddressDetails: PropTypes.func.isRequired,
    getCompanyPaymentAction: PropTypes.func.isRequired,
    createStripeCustomerWithCard: PropTypes.func.isRequired,
    clearCompanyDetailsAction: PropTypes.func.isRequired,
    searchWorkersAction: PropTypes.func.isRequired,
    searchWorkersForFavorites: PropTypes.func.isRequired,
    clearWorkersPredictionsList: PropTypes.func.isRequired,
    addCompanyLTAWorker: PropTypes.func.isRequired,
    removeCompanyLTAWorker: PropTypes.func.isRequired,
    getCompanyLTAWorkers: PropTypes.func.isRequired,
    getCompanyFavAndBlocks: PropTypes.func.isRequired,
    deleteCompanyWorker: PropTypes.func.isRequired,
    UIShowConfirm: PropTypes.func.isRequired,
    UIShowAlert: PropTypes.func.isRequired,
    deletePaymentInfo: PropTypes.func.isRequired
  };

  state = {
    activeTab: companyTabs.details,
    isLoading: true
  };

  componentDidMount () {
    const { getCompanyDetailsAction, match: { params: { id } }, history } = this.props;
    if (isNaN(id)) {
      return history.push(`/${appPath}/companies`);
    }

    getCompanyDetailsAction(id)
      .then(this._setDataLoaded);
  }

  componentWillUnmount () {
    this.props.clearCompanyDetailsAction();
  }

  _setDataLoaded = () => {
    const hash = stripHash(this.props.location.hash);

    if (Object.values(companyTabs).includes(hash)) {
      this.setState({ activeTab: hash });
    }

    this.setState({ isLoading: false });
  };

  setActiveTab = (activeTab, event) => {
    event.preventDefault();
    this.setState({ activeTab });
    pushHistoryState(`${this.props.match.url}#${activeTab}`);
  };

  _renderTabs = () => {
    let RenderTab = null;

    switch (this.state.activeTab) {
      case companyTabs.details:
        RenderTab = Details;
        break;
      case companyTabs.locations:
        RenderTab = Locations;
        break;
      case companyTabs.departments:
        RenderTab = Departments;
        break;
      case companyTabs.contacts:
        RenderTab = Contacts;
        break;
      case companyTabs.payment:
        RenderTab = Payment;
        break;
      case companyTabs.rates:
        RenderTab = Rates;
        break;
      case companyTabs.workers:
        RenderTab = Workers;
        break;
      default:
        RenderTab = Teaser;
    }

    return <RenderTab {...this.props} />;
  };

  render () {
    if (this.state.isLoading) {
      return <div className='loader-wrapper'><Loader /></div>;
    }

    const { company: { company_name }, location } = this.props;
    const { activeTab } = this.state;

    return (
      <div>
        <div className='d-flex align-items-center mb-4'>
          <BackArrow
            history={this.props.history}
            location={this.props.location}
            defaultBackPath={`/${appPath}/companies`}
          />
          <h1 className='h1 m-0'>{company_name}</h1>
        </div>

        <ul className='nav nav-tabs mt-1'>
          {Object.values(companyTabs).map(tab => (
            <li className='nav-item' key={tab}>
              <a onClick={event => this.setActiveTab(tab, event)}
                href={`${location.pathname}#${tab}`}
                className={`nav-link ${activeTab === tab && 'active'}`}>{tab}</a>
            </li>
          ))}
        </ul>

        <ul className='list-group flex-1'>
          <li className='list-group-item list-group-item-content border-top-0 pt-4 border-radius-top-0'>
            {this._renderTabs()}
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    company: state.companies.companyDetails,
    skillsList: state.skillsList,
    skillLevels: state.skillLevels,
    companyLocations: state.companyLocations,
    locationsList: state.locations.locationsList,
    workersPredictionsList: state.users.workersPredictionsList
  };
};

const mapDispatchToProps = {
  getAllSkills,
  getSkillLevels,
  getCompanyLocations,
  getLocationsListAction,
  getGoogleAddressDetails,
  UIShowConfirm,
  UIShowAlert,
  searchWorkersAction,
  clearWorkersPredictionsList,
  searchWorkersForFavorites,
  ...companiesActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetails);



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/index.js